/*** IMPORTS FROM imports-loader ***/
var define = false;

import "../../utilities/globals/index.js";
export { parseAndCheckHttpResponse } from "./parseAndCheckHttpResponse.js";
export { serializeFetchParameter } from "./serializeFetchParameter.js";
export { fallbackHttpConfig, defaultPrinter, selectHttpOptionsAndBody, selectHttpOptionsAndBodyInternal } from "./selectHttpOptionsAndBody.js";
export { checkFetcher } from "./checkFetcher.js";
export { createSignalIfSupported } from "./createSignalIfSupported.js";
export { selectURI } from "./selectURI.js";
export { createHttpLink } from "./createHttpLink.js";
export { HttpLink } from "./HttpLink.js";
export { rewriteURIForGET } from "./rewriteURIForGET.js";
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/link/http/index.js
// module id = 742
// module chunks = 0